import styled from 'styled-components';

export const PaginationWrapper = styled.section`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem;
  font-size: 0.8em;
`;

export const RowsPerPageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  color: #000;

  .rows-per-page-dropdown {
    padding: 0.25rem;
    cursor: pointer;
    border: none;
    border-bottom: #000;
    background-color: alicblue;
    color: #000;
  }
`;

export const StyledPagination = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  .pagination-icon-button {
    border: none;
    border-radius: 0.3rem;
    cursor: pointer;
    padding: 0.25rem;
    display: flex;
    align-items: center;
    transition: 0.25s ease;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.4;
    }

    .pagination-icon {
      width: 1.5em;
      height: 1.5em;
    }
  }

  .page-numbers-wrapper {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    border-radius: 0.3rem;

    button {
      // display: flex;
      // width: 2.25em;
      // height: 2.25em;
      // // background-color: transparent;
      // border: none;
      // align-items: center;
      // justify-content: center;
      // cursor: pointer;
      // border-radius: 0.3rem;
      // // transition: 0.25s ease;

      //   &:disabled {
      //       cursor: not-allowed;
      //   }
      // }
    }
  }
`;
